// sfBridge.js
// Lightweight bridge: React (Sales Map iframe) → Salesforce Aura parent via postMessage.
 
const ENV = (typeof window !== 'undefined' && window.__ENV) || {};

const getSalesforceBase = () => {
try {
    const b = useMapStore.getState().salesforceBaseUrl;
    return (b && b.trim()) ? b.replace(/\/+$/, '') : 'https://sysco--training.sandbox.lightning.force.com';
} catch { 
    return 'https://sysco--training.sandbox.lightning.force.com';
}
};
const SF_ORIGIN = getSalesforceBase();
 
/** Detect if this window is running inside an iframe (Canvas). */
function isEmbedded() {
  try {
    return typeof window !== 'undefined' && window.parent && window.parent !== window;
  } catch {
    return false;
  }
}
 
/**
* Trigger the Salesforce Aura wrapper to open the Quick Action for this Account.
* No return channel or acknowledgement is expected.
*/
export function openSalesCallPlan(accountId) {
    console.log('openSalesCallPlan called with accountId:', accountId, isEmbedded(), SF_ORIGIN);
  if (!isEmbedded()) {
    console.warn('[SalesMap→SF] Not embedded (no parent window). Cannot postMessage.');
    return;
  }
 
  if (!SF_ORIGIN) {
    console.warn('[SalesMap→SF] Missing Salesforce origin. Please set VITE_SALESFORCE_ORIGIN.');
    return;
  }
 
  const payload = {
    source: 'SalesMap',
    type: 'OPEN_CALL_PLAN',
    accountId,
    ts: Date.now(),
  };
 
  try {
    window.top.postMessage(payload, '*');
    console.info('[SalesMap→SF] OPEN_CALL_PLAN sent', payload);
  } catch (err) {
    console.error('[SalesMap→SF] Failed to postMessage to Salesforce parent:', err);
  }
}
 
export default { openSalesCallPlan };